import { useIsFetching, useIsMutating } from '@tanstack/react-query'
import classes from './GlobalLoadingIndicator.module.css'

const GlobalLoadingIndicator = () => {
  const fetching = useIsFetching()
  const mutating = useIsMutating()
  const active = fetching > 0 || mutating > 0

  return (
    <div
      data-testid="global-loading-indicator"
      data-loading={active ? 'true' : 'false'}
      className={classes.root}
      role="progressbar"
    >
      {active && <div className={classes.bar} />}
    </div>
  )
}

export default GlobalLoadingIndicator
